import './index.scss';
import React, { useRef } from 'react';
import { motion, useMotionValue, useTransform, useInView } from 'framer-motion';
import HolzwegLogoSmall from '../HolzwegLogoSmall';

const QuickFact = ({ fact, color }) => {
  const count = useMotionValue(0);
  const roundedCount = useTransform(count, value => Math.round(value).toLocaleString('de-DE'));

  const ref = useRef(null);
  const isInView = useInView(ref, { threshold: 0.1, once: true });

  return (
    <div ref={ref} className={`quick-fact ${color}`}>
      <div className="quick-fact__number">
        <motion.span
          initial={{ content: 0 }}
          animate={isInView ? { content: fact.count } : { content: 0 }}
          transition={{ stiffness: 50, damping: 30, duration: 2 }}
          style={{ content: count }}
        >
          {roundedCount}
        </motion.span>
        {fact.suffix}
      </div>
      <div className="quick-fact__text">{fact.text}</div>
    </div>
  );
};

const QuickFacts = ({ facts, color, noSpace }) => {
  return (
    <div className={`quick-facts quick-facts--${noSpace ? 'no-space' : 'space'}`}>
      <div className="quick-facts__wrapper">
        {facts.map((fact, index) => (
          <QuickFact key={index} fact={fact} color={color} />
        ))}
      </div>
      <div className={`quick-facts__background ${color}`}>
        <HolzwegLogoSmall className="quick-facts__holzweg-logo-small" />
      </div>
    </div>
  );
};

export default QuickFacts;
